import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SkillsSection } from './components/SkillsSection';
import { BonusSection } from './components/BonusSection';
import { OverviewSection } from './components/OverviewSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { VersatilitySection } from './components/VersatilitySection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStackSection } from './components/ValueStackSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0" data-mp="3dl4jnkfqldua">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1" data-mp="nw2e2bl1k0tq">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="nuhiqjqwkdut" />
      </noscript>

      <UrgencyBar data-id="element-3" data-mp="35ynugqx9fzv" />

      <main data-id="element-4" data-mp="35ghusegjner">
        <HeroSection data-id="element-5" data-mp="34x0pdwmt31s" />
        <PainSection data-id="element-6" data-mp="38kvshhq5xim" />
        <ProblemSection data-id="element-7" data-mp="3ud1gzdqblwcq" />
        <SolutionSection data-id="element-8" data-mp="3udkr489qbgg7" />
        <SkillsSection data-id="element-9" data-mp="3uc9i9u1ffii8" />
        <OverviewSection data-id="element-10" data-mp="3uf5i5nwu4h9b" />
        <BonusSection data-id="element-11" data-mp="d57gn6a1wokn" />
        <BeforeAfterSection data-id="element-12" data-mp="d3mmvivk99nu" />
        <VersatilitySection data-id="element-13" data-mp="d3wax0x1p6qw" />
        <MidPageCTA data-id="element-14" data-mp="85l1granwy97" />
        <ValueStackSection data-id="element-15" data-mp="85bbv4tj4t41" />
        <PurchaseSection data-id="element-16" data-mp="864a1hefaaak" />

        <section className="py-6 px-4 bg-white" data-id="element-17" data-mp="83i6rtykegy5">
          <div className="max-w-3xl mx-auto text-center" data-id="element-18" data-mp="3gmfw5jhb3cc7">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-19" data-mp="3bmbdpnwu87jc">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-20" data-mp="3ljg27ue5of3b" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-21" data-mp="3lieg8uvlq86t">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-22" data-mp="2xtbyln0ywfcb">
          <p className="text-sm text-gray-300" data-id="element-23" data-mp="2sw24hu2mvfi5">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-24" data-mp="18cq6rn0wyktz">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-25" data-mp="13f7v3ovihria" />
    </div>;
}